enum ContentType {
  APPLICATION_CSV = 'application/csv',
  APPLICATION_JSON = 'application/json',
  APPLICATION_JSON_UTF_8 = 'application/json;charset=UTF-8'
}

export default ContentType;
